import {GlobalProvider} from '../providers/global-provider';

export function initApp(global: GlobalProvider) {
    // Init required providers before load the app
    // NOTE: this factory needs to return a function (that then returns a promise)
    return () => global.load();  // + any other providers...
}
